import { request } from '@umijs/max';

export const WORKSPACE_STORAGE_KEY = 'ghostore.workspaceId';

export async function listWorkspaces(options?: { [key: string]: any }) {
  return request<{
    success: boolean;
    data: Array<{
      id: number;
      name: string;
      slug: string;
      type: string;
      role?: string;
    }>;
    current?: any;
  }>('/api/workspaces', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function createWorkspace(
  body: { name: string; slug?: string },
  options?: { [key: string]: any },
) {
  return request<{ success: boolean; data: any }>('/api/workspaces', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}
